import { Dashboard, PageLayout } from '@components/common';
import { BaseContent, Button, EmptyState, HeadContent, Icon, Loading, ToolbarButton, useMediaQueryContext, } from '@fourthwall/components';
import { DownloadIcon, UploadIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import * as S from './styled';
export const OrdersFulfillmentView = ({ ordersToManuallyFulfill, isDownloading, isUploading, onDownload, onUpload, }) => {
    const media = useMediaQueryContext();
    const title = `To be shipped ${ordersToManuallyFulfill ? `(${ordersToManuallyFulfill})` : ''}`;
    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles[0] && onUpload) {
            const payload = new FormData();
            payload.append('csv', acceptedFiles[0]);
            onUpload(payload);
        }
    }, [onUpload]);
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: { 'text/csv': ['.csv'] },
        maxSize: 104857600,
        disabled: isUploading,
        multiple: false,
    });
    const renderToolbar = () => {
        if (!media.tablet) {
            return (React.createElement(ToolbarButton, { label: "Download CSV of unshipped orders", icon: DownloadIcon, isLoading: isDownloading, onClick: onDownload }));
        }
        return (React.createElement(Button, { label: "Download CSV of unshipped orders", size: "small", loading: isDownloading, onClick: onDownload }));
    };
    const renderPage = () => {
        if (!ordersToManuallyFulfill) {
            return (React.createElement(PageLayout, { size: "large" },
                React.createElement(Dashboard.Section, { name: title }),
                React.createElement(S.EmptyStateContainer, null,
                    React.createElement(EmptyState, { title: "You don\u2019t have any orders waiting to be shipped" }))));
        }
        return (React.createElement(PageLayout, { size: "large" },
            React.createElement(Dashboard.Section, { name: title, toolbarContent: renderToolbar(), title: React.createElement(BaseContent, { appearance: "primary" },
                    "You currently have ",
                    ordersToManuallyFulfill,
                    " orders that need to be shipped. To access shipping information",
                    ' ',
                    React.createElement("button", { onClick: onDownload }, "download the CSV of unshipped orders"),
                    ". Once the orders are shipped you can add the tracking numbers to the downloaded CSV, then upload it below.",
                    ' ',
                    React.createElement("a", { href: routing.external.helpCenter.selfFulfillment, target: "_blank", rel: "noreferrer" }, "Learn more")), titleSpacing: "large" }, onUpload && (React.createElement(Loading, { isLoading: isUploading },
                React.createElement(S.UploadContainer, { ...getRootProps() },
                    React.createElement("input", { ...getInputProps() }),
                    React.createElement(S.UploadContent, null,
                        React.createElement("div", { style: { marginBottom: 20 } },
                            React.createElement(Icon, { component: UploadIcon, height: 22 })),
                        media.tablet && (React.createElement(React.Fragment, null,
                            React.createElement("div", { style: { marginBottom: 26 } }, "Drag and drop CSV with tracking information"),
                            React.createElement(S.Divider, null, "or"))),
                        React.createElement(Button, { label: "Upload CSV with tracking information", appearance: "primary" }))))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: title }),
        renderPage()));
};
